import { backend } from 'modules/data';
import { z } from 'zod';

import { fieldNameSelectedCompanies, fieldNameWatchType } from './SlackConnectForm.constants';
import { messages } from './SlackConnectForm.messages';

export const schema = z
    .object({
        [fieldNameWatchType]: z.nativeEnum(backend.transfers.CompaniesWatchType, { message: messages.errorWatchType }),
        [fieldNameSelectedCompanies]: z.array(z.string(), { message: messages.errorSelectedCompaniesWrongValue }),
    })
    .superRefine((data, ctx) => {
        if (
            data[fieldNameWatchType] === backend.transfers.CompaniesWatchType.All &&
            data[fieldNameSelectedCompanies].length > 0
        ) {
            ctx.addIssue({
                path: [fieldNameSelectedCompanies],
                message: messages.errorSelectedCompaniesNotEmpty,
                code: 'custom',
            });
        }

        if (
            data[fieldNameWatchType] === backend.transfers.CompaniesWatchType.Selected &&
            data[fieldNameSelectedCompanies].length === 0
        ) {
            ctx.addIssue({
                path: [fieldNameSelectedCompanies],
                message: messages.errorSelectedCompaniesEmpty,
                code: 'custom',
            });
        }
    });
